import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink
              target="_blank"
              href="https://www.zomato.com/vancouver/sushi-topia-newton-surrey"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Sushi Topia Zomato"
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.yelp.ca/biz/sushi-topia-surrey-2">
              <CFImage
                w="45px"
                pr="10px"
                src={yelp}
                alt="Sushi Topia Yelp"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink
              target="_blank"
              href="https://www.zomato.com/vancouver/sushi-topia-newton-surrey"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Sushi Topia Zomato"
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.yelp.ca/biz/sushi-topia-surrey-2">
              <CFImage
                w="45px"
                pr="10px"
                src={yelp}
                alt="Sushi Topia Yelp"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
